import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import TextInput from '../../../common/forms/input/TextInput';
import { ENDPOINT_PERMISSION_TYPE } from '../../../../config/constants';
import Select from '../../../common/forms/select/Select';
import FormItem from '../../../common/forms/FormItem';
import { isRequired } from '../../../../utils/validators';
import { enumToSelectOptions } from '../../../../utils/enum';

export const EndpointFormFields = () => (
    <>
      <FormGroup row>
        <FormItem label="Nombre" required={[[isRequired]]}>
          <Field
            name="name"
            component={TextInput}
            type="text"
            placeholder="Nombre"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descripción">
          <Field
            name="description"
            component={TextInput}
            type="textarea"
            placeholder="Descripción"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Ruta" required={[[isRequired]]}>
          <Field
            name="route"
            component={TextInput}
            type="text"
            placeholder="Ruta"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tipo de Permiso" required={[[isRequired]]}>
          <Field
            name="permissionType"
            id="permissionType"
            component={Select}
            options={enumToSelectOptions(ENDPOINT_PERMISSION_TYPE)}
            showToolTip
            placeholder="Select"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
    </>
  );

EndpointFormFields.propTypes = {
  initialValues: PropTypes.shape({
    permissionType: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

EndpointFormFields.defaultProps = {
  initialValues: null,
};

export default EndpointFormFields;
